export default __webpack_public_path__ + "static/media/businessCenterDark.2aed814c.svg";